/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Amarantos API
 * REST API for the Amarantos construction and infrastructure management platform. Supports both the Panel (web) and App (mobile) clients.
 *
 * OpenAPI spec version: 1.0.0
 */

/**
 * The update's kind, in four groups: progress (`completed`, `in_progress`, `on_hold`) on network elements, issue (`damaged`, `material_shortage`, `other_issue`) on any subject, and `delivery` and `consumption` on a `Material` alone. An `other_issue` is the catch-all for a field problem that is neither damage nor a shortage (foreign material left on the trench line, say); its `description` carries the content. Like every issue it takes no `quantity`, and while unresolved it sets the element's `has_open_issue`. A `consumption` records what was taken off the site stock and built in (ADR-0049): it requires a strictly positive `quantity`, counts towards the material's `consumed_quantity` the moment it is created, may exceed what was delivered, and is corrected by editing or deleting the entry.
 */
export type WorkStatusType = typeof WorkStatusType[keyof typeof WorkStatusType];


export const WorkStatusType = {
  completed: 'completed',
  in_progress: 'in_progress',
  on_hold: 'on_hold',
  damaged: 'damaged',
  material_shortage: 'material_shortage',
  other_issue: 'other_issue',
  delivery: 'delivery',
  consumption: 'consumption',
} as const;
